<template>
  <div>
    <vxe-grid
      ref="orderGoodsTable"
      resizable
      auto-resize
      highlight-hover-row
      show-footer
      row-id="noticeOrderGoodsCode"
      class="notice-order-goods"
      size="mini"
      :tree-config="treeConfig"
      :toolbar-config="toolbarConfig"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :cell-class-name="cellClassName"
      :row-style="rowStyle"
      :footer-method="() => footerData"
      :edit-config="{ enabled: disabled, trigger: 'click', mode: 'row' }"
      :edit-rules="rules"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          v-if="!(row.noticeOrderGoodsSpecCode && row.isGroup == 'N')"
          :src="row.defaultImageUrl || '/image/static/img/nopic.jpg'"
          style="width:60px; height:60px"
          @click="imgClick(row)"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:showGoods="{ row }">
        <div v-if="!row.noticeOrderGoodsSpecCode">
          <div>{{ row.orderGoodsName }}</div>
          <div>{{ row.orderGoodsNameEn }}</div>
          <div>
            <span>{{ row.orderGoodsColor }}</span>
            <span>{{ row.orderGoodsColorEn }}</span>
          </div>
          <div>{{ row.orderGoodsSpecShow }}</div>
        </div>

        <div v-if="!!row.noticeOrderGoodsSpecCode && row.isGroup == 'Y'">
          <div>
            <span>{{ $l('table_value_group_specName') || '子件名称' }}:</span>
            <span>{{ row.orderGoodsName }}</span>
          </div>
          <div>
            <span>{{ $l('table_value_group_specSize') || '子件尺寸' }}:</span>
            <span>{{ row.orderGoodsSpecShow }}</span>
          </div>
        </div>

        <div v-if="!!row.noticeOrderGoodsSpecCode && row.isGroup == 'N'">
          <div>
            <span>{{ $l('table_value_specName') || '规格名称' }}:</span>
            <span>{{ row.orderGoodsName }}</span>
          </div>
          <div>
            <span>{{ $l('table_value_specSize') || '规格尺寸' }}:</span>
            <span>{{ row.orderGoodsSpecShow }}</span>
          </div>
        </div>
      </template>
      <template v-slot:showGoodsIdentify="{ row }">
        <div v-for="(identify, index) in row.listIdentifyGoodsNo" :key="index">
          {{ identify }}
        </div>
      </template>
      <template v-slot:orderQty="{ row }">
        <div>{{ format(row.orderQty) }}</div>
        <div v-if="row.isGroup && !row.noticeOrderGoodsSpecCode" class="mt-1">
          <el-tag
            style="margin: 0;"
            size="mini"
            :type="
              row.isGroup == 'Y'
                ? 'warning'
                : row.isGroup === 'N'
                ? 'primary'
                : ''
            "
          >
            {{ row.v_isGroup }}
          </el-tag>
        </div>
      </template>
      <template v-slot:edit-ncNo="{ row }">
        <div
          class="pt-1"
          style="margin-top:7px;"
          v-if="!(row.noticeOrderGoodsSpecCode && row.isGroup == 'N')"
        >
          <el-input
            ref="ncInput"
            v-model.trim="row.ncNo"
            :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            :maxlength="50"
            clearable
            :disabled="!disabled"
            size="mini"
            @clear="ncClear(row)"
            @change="ncChange(row)"
            @blur="ncBlur(row)"
          />
        </div>
      </template>
      <template v-slot:default-ncNo="{ row }">
        <div
          class="pt-1"
          v-if="!(row.noticeOrderGoodsSpecCode && row.isGroup == 'N')"
        >
          <el-input
            v-model="row.ncNo"
            :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            readonly
            :disabled="!disabled"
            size="mini"
          />
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>

    <div
      v-show="false"
      class="pdOrderGoodsImgViews"
      v-viewer="{ movable: true }"
    >
      <img
        v-for="(item, index) in viewerImgs"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { add, format, multiply } from '@/libs/util.number.js'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      treeConfig: { reserve: true, expandAll: true, children: 'childs' },
      toolbarConfig: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
      },
      tableColumns: tableColumns(this),
      format: (number) => format(number),
      multiply: (x, y) => multiply(x, y),
      viewerImgs: [],
      viewer: null,
      rules: {
        ncNo: [
          {
            validator: ({ row, cellValue }) => {
              const { noticeOrderGoodsSpecCode, isGroup } = row
              if (noticeOrderGoodsSpecCode && isGroup == 'N') return
              if (cellValue) return
              return new Error(
                this.$l('INDEX.tips_input_placeholder') || '请输入...'
              )
            },
          },
        ],
      },
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns.map((t) => {
        const val = totalColumnValues[t.field] || ''
        return val ? val.toLocaleString() : ''
      })
      result[0] = '合计'
      return [result]
    },
  },
  methods: {
    cellClassName({ column, row }) {
      const { property } = column
      const { noticeOrderGoodsSpecCode } = row
      if (property !== 'col-opt' || !noticeOrderGoodsSpecCode) {
        return 'align-top'
      }
      return 'goods-spec-col-opt align-top'
    },
    rowStyle({ row }) {
      const { noticeOrderGoodsSpecCode } = row
      if (!noticeOrderGoodsSpecCode) return {}
      return { 'background-color': '#fafafa' }
    },
    async validate() {
      return !(await this.$refs.orderGoodsTable.validate(true))
    },
    setAllTreeExpand(checked = true) {
      this.$refs.orderGoodsTable.setAllTreeExpand(checked)
    },
    clearTreeExpand() {
      this.$refs.orderGoodsTable.clearTreeExpand()
    },
    imgClick({ listImg }) {
      listImg =
        !listImg || !listImg.length ? ['/image/static/img/nopic.jpg'] : listImg
      this.viewerImgs = [...(listImg || []).map((item) => item.displayImageUrl)]
      if (this.viewer) this.viewer.destroy()
      setTimeout(() => {
        this.viewer = this.$el.querySelector('.pdOrderGoodsImgViews').$viewer
        this.viewer.update()
        let defaultIndex = (listImg || []).findIndex(
          (item) => item.isDefault == 'Y'
        )
        defaultIndex = defaultIndex < 0 ? 0 : defaultIndex
        setTimeout(() => {
          this.viewer.view(defaultIndex)
          this.viewer.show()
        }, 0)
      }, 0)
    },
    ncClear(row) {
      row.clear = true
      this.$refs.ncInput.focus()
    },
    ncChange(row) {
      setTimeout(async () => {
        const { clear, ncNo, oldNcNo } = row
        if (clear || ncNo == oldNcNo) return
        await this.setNc(row)
        row.oldNcNo = ncNo
        // this.$emit('reload')
      }, 0)
    },
    async ncBlur(row) {
      const { clear, ncNo, oldNcNo } = row
      row.clear = false
      if (!clear || ncNo == oldNcNo) return
      if (!(await this.setNc(row))) return
      row.oldNcNo = ncNo
      // this.$emit('reload')
    },
    async setNc({ ncNo, noticeOrderGoodsCode, noticeOrderGoodsSpecCode }) {
      const goods = { ncNo, noticeOrderGoodsCode }
      const spec = { ncNo, noticeOrderGoodsSpecCode }
      if (noticeOrderGoodsSpecCode) {
        await this.$api
          .noticeOrderGoodsSpecSetNcApi(spec)
          .then((res) => {
            const { status } = res
            if (status !== 200) {
              this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
              return
            }
            return true
          })
          .catch(() => {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return false
          })
      } else {
        await this.$api
          .noticeOrderGoodsSetNcApi(goods)
          .then((res) => {
            const { status } = res
            if (status !== 200) {
              this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
              return
            }
            return true
          })
          .catch(() => {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return false
          })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .notice-order-goods {
    .goods-spec-col-opt {
      .vxe-tree-cell {
        padding-left: 0 !important;
      }
    }
    .vxe-body--column {
      .vxe-cell div {
        span:first-child {
          margin-right: 10px;
        }
      }
    }
    .vxe-body--row:first-child .vxe-cell--valid {
      top: initial !important;
      bottom: auto !important;
    }
    .vxe-cell--valid {
      bottom: calc(100% + -10px) !important;
    }
  }
}
</style>
